export default __webpack_public_path__ + "static/media/userIcon.42f22970.svg";